<template>
	<div class="toaster">
		<TransitionGroup name="slide-in-top">
			<div
				class="toaster__container flex-center"
				v-for="toast in toasts"
				:key="`toast-${toast.id}`"
				@click="removeToast(toast.id)"
				:aria-label="toast.id"
			>
				<svg
					v-if="toast.type === 'success'"
					class="toaster__icon toaster__icon--success"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="currentColor"
				>
					<path
						fill-rule="evenodd"
						d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
						clip-rule="evenodd"
					/>
				</svg>
				<svg
					v-else-if="toast.type === 'error'"
					class="toaster__icon toaster__icon--error"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="currentColor"
				>
					<path
						fill-rule="evenodd"
						d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
						clip-rule="evenodd"
					/>
				</svg>
				<span class="toaster__message">
					{{ toast.message }}
				</span>
			</div>
		</TransitionGroup>
	</div>
</template>

<script setup>
import { useToast } from "@/vue/composables/useToast";

const { toasts, removeToast } = useToast();
</script>
